// extracted by mini-css-extract-plugin
module.exports = {"ClientWrapper":"ClientList_ClientWrapper__2vz1-","ClientList":"ClientList_ClientList__1dkWK"};